// DataSyncManager.js
import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserLoads } from '../store/slices/loadSlice';
import WebSocketManager from '../websocket/WebSocketManager';
import { updateWebSocketStatus } from '../store/slices/websocketSlice';
import { store } from '../store/store';

const DataSyncManager = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const lastSyncTimestamp = useSelector((state) => state.load.lastSyncTimestamp);
  const accessToken = useSelector((state) => state.auth.accessToken);
  const refreshToken = useSelector((state) => state.auth.refreshToken);

  const handleWebSocketStatus = useCallback((status) => {
    dispatch(updateWebSocketStatus(status));
  }, [dispatch]);

  const getCurrentTokens = useCallback(() => {
    const state = store.getState();
    return {
      accessToken: state.auth.accessToken,
      refreshToken: state.auth.refreshToken,
      lastSyncTimestamp: state.load.lastSyncTimestamp
    };
  }, []);

  useEffect(() => {
    WebSocketManager.setConnectionStatusCallback(handleWebSocketStatus);
    WebSocketManager.setCurrentTokensCallback(getCurrentTokens);
    return () => {
      WebSocketManager.setConnectionStatusCallback(null);
      WebSocketManager.setCurrentTokensCallback(null);
    };
  }, [handleWebSocketStatus, getCurrentTokens]);

  const connectWebSocket = useCallback(() => {
    if (isAuthenticated && accessToken && refreshToken && !WebSocketManager.isConnected()) {
      WebSocketManager.connect(accessToken, refreshToken);
    }
  }, [isAuthenticated, accessToken, refreshToken]);

  useEffect(() => {
    if (isAuthenticated && accessToken && refreshToken) {
      connectWebSocket();
    }
    // We don't need to call disconnect here, as it's handled in the logout action
  }, [isAuthenticated, accessToken, refreshToken, connectWebSocket]);

  useEffect(() => {
    if (isAuthenticated && !lastSyncTimestamp) {
      dispatch(fetchUserLoads({ page: 1, perPage: 50 }));
    }
  }, [dispatch, isAuthenticated, lastSyncTimestamp]);

  return null; // This component doesn't render anything
};

export default DataSyncManager;
